import Icon from '../components/Icon.vue'

Icon.register({
  'prescription-bottle': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M32 192H152C156.4 192 160 195.6 160 200V216C160 220.4 156.4 224 152 224H32V288H152C156.4 288 160 291.6 160 296V312C160 316.4 156.4 320 152 320H32V384H152C156.4 384 160 387.6 160 392V408C160 412.4 156.4 416 152 416H32V480C32 497.6 46.4 512 64 512H320C337.6 512 352 497.6 352 480V128H32V192zM360 0H24C10.8 0 0 10.8 0 24V72C0 85.2 10.8 96 24 96H360C373.2 96 384 85.2 384 72V24C384 10.8 373.2 0 360 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/prescription-bottle.js
// module id = SIEK
// module chunks = 144